import * as angular from "angular";
import * as moment from "moment";
import { IGeofence } from "@interfaces/IGeofences";
import { GeofenceService, IGeofenceVisit } from "@services/geofence.service";
import { VeriDate } from "@services/veriDate.service";
import "./geofenceVisits.scss";

interface IGeofenceVisitsBindings {
    geofence: IGeofence;
}

class GeofenceVisitsComponentController implements angular.IComponentController, IGeofenceVisitsBindings {
    loadingGeofenceVisits: boolean;
    geofenceVisits: IGeofenceVisit[];

    geofenceVisitDate: moment.Moment;
    geofence: IGeofence;

    static $inject = ["geofenceService", "veriDate"];

    constructor(private readonly geofenceService: GeofenceService, private readonly veriDate: VeriDate) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["geofence"]) {
            this.loadGeofenceVisits();
        }
    }

    private loadGeofenceVisits(date?: Date) {
        this.loadingGeofenceVisits = true;

        if (date) {
            this.geofenceVisitDate = moment(date).startOf("day");
        }
        else {
            this.geofenceVisitDate = moment().startOf("day");
        }

        this.geofenceService
            .getGeofenceVisitsByGeofence(this.geofence.Id, this.geofenceVisitDate, this.geofenceVisitDate.clone().add(1, "day"))
            .then(visits => {
                visits = visits.filter(v => moment(v.StartUtc).isSameOrAfter(moment(this.geofenceVisitDate).startOf("day")));

                visits.forEach(visit => {
                    visit.duration = this.veriDate.formatDuration(moment(visit.StartUtc), moment(visit.EndUtc));
                });

                this.geofenceVisits = visits;                

            })
            .finally(() => {
                this.loadingGeofenceVisits = false;
            });
    }
}

export class GeofenceVisitsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            geofence: "<"
        };

        this.controller = GeofenceVisitsComponentController;
        this.template = require("./geofenceVisits.html");
    }
}
